(() => {
  const money = n => new Intl.NumberFormat('en-US', {style:'currency',currency:'USD',maximumFractionDigits:2}).format(n);
  function init(root = document) {
    root.querySelectorAll('[data-rtm-calculator]').forEach(calc => {
      if(calc.dataset.ready) return;
      calc.dataset.ready = 'true';
      const form = calc.querySelector('form');
      form.querySelector('[type="submit"]').disabled = false;
      const update = () => {
        if(!form.reportValidity()) return;
        const values = Object.fromEntries(new FormData(form));
        const {collected,codes,biller,months,device,clinic,patients} = Object.fromEntries(Object.entries(values).map(([k,v])=>[k,Number(v)]));
        const monthly=collected-codes*25,afterBiller=monthly-collected*biller/100;
        const gross=collected*months,partner=codes*25*months,billing=gross*biller/100;
        const net=gross-partner-billing-device-clinic;
        const output={monthly:money(monthly),afterBiller:money(afterBiller),gross:money(gross),partner:'-'+money(partner),billing:'-'+money(billing),device:'-'+money(device),clinic:clinic?'-'+money(clinic):money(0),net:money(net),cohort:money(net*patients),patients:String(patients),warning:net<0?'This scenario has a negative contribution. Reassess costs and expected collections.':clinic===0?'Other practice costs are still $0. Enter them before assessing viability.':'These are scenario outputs, not a coverage determination or guaranteed return.'};
        Object.entries(output).forEach(([key,value])=>calc.querySelector(`[data-result="${key}"]`).textContent=value);
      };
      form.addEventListener('submit',event=>{event.preventDefault();update();});
      form.addEventListener('reset',()=>setTimeout(update,0));
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
